/* eslint-disable react/static-property-placement */
import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';
import FontFaceObserver from 'fontfaceobserver';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { getFontNameFromGoogleFontUrl } from '../../../helpers/fonts';
import fakePreviewShipments from '../../../constants/fakeData';
import ShipmentsSelector from './ShipmentsSelector';
import styles from './styles.scss';
import ShipmentDetails from './ShipmentDetails';

class TrackingComponent extends Component {
  static propTypes = {
    isTrackingPageFontExisted: propTypes.bool,
    rowItem: propTypes.shape({
      font: propTypes.shape({
        url: propTypes.string,
      }),
    }),
  };

  static defaultProps = {
    rowItem: {},
    isTrackingPageFontExisted: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      uploadedRowItemFont: null,
      selectedShipmentIndex: 0,
    };
  }

  componentDidMount() {
    if (this.props.rowItem.font && this.props.rowItem.font.url) {
      const rowItemFont = new FontFaceObserver(getFontNameFromGoogleFontUrl(this.props.rowItem.font.url));
      rowItemFont.load(null, 6000).then((loadedFont) => this.setState({
        uploadedRowItemFont: loadedFont,
      }));
    }

    const searchValue = window.location.search;
    const pattern = /(?:tracking_reference|shipment_id)=([^&]+)/;
    const match = searchValue?.match(pattern);
    if (match) {
      const currentShipmentIndex = this.shipmentsToRender
        .findIndex((s) => s.trackingReference === match[1] || s.id === match[1]);
      this.setState({
        selectedShipmentIndex: currentShipmentIndex,
      });
    }
  }

  get shipmentsToRender() {
    return this.props.isPreview ? fakePreviewShipments : this.props.shipments;
  }

  render() {
    const {
      isTrackingPageFontExisted,
      rowItem,
      uploadedTrackingPageFont,
      location: { search },
    } = this.props;
    const {
      shipmentsToRender,
    } = this;

    const {
      metadata_key: metadataKey,
      metadata_value: metadataValue,
    } = queryString.parse(search);

    const {
      selectedShipmentIndex,
      uploadedRowItemFont,
    } = this.state;
    if ((rowItem.font && rowItem.font.url && !uploadedRowItemFont)
      || (rowItem.font && !rowItem.font.url && isTrackingPageFontExisted && !uploadedTrackingPageFont)) {
      return '';
    }

    let fontFamily;
    if (uploadedRowItemFont) {
      fontFamily = {
        fontFamily: uploadedRowItemFont.family,
      };
    }
    if ((!rowItem.font || (rowItem.font && !rowItem.font.url)) && uploadedTrackingPageFont) {
      fontFamily = {
        fontFamily: uploadedTrackingPageFont.family,
      };
    }
    const shipment = shipmentsToRender[selectedShipmentIndex];

    return (
      <div className={styles.trackingCompContainer}>
        {shipmentsToRender.length > 1 && (
          <>
            <div className={styles.selectContainer}>
              <p className={styles.selectLabel}>Your order will be shipped in multiple parcels:</p>
              <ShipmentsSelector
                shipments={shipmentsToRender}
                selectedIndex={selectedShipmentIndex}
                onSelect={(i) => this.setState({ selectedShipmentIndex: i })}
              />
            </div>
            {metadataKey && metadataValue
              && (
                <p className={styles.metadata}>
                  <strong>{`${shipment.metadataName || metadataKey}: `}</strong>{metadataValue}
                  <br />
                </p>
              )}
          </>
        )}
        <ShipmentDetails
          shipment={shipment}
          fontFamily={fontFamily}
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  trackingPage: {
    shipments, trackingPageData: { font: trackingPageFont }, isPreview,
  },
}) => ({
  shipments,
  trackingPageFont,
  isPreview,
});

export { TrackingComponent };
export default withRouter(connect(mapStateToProps)(TrackingComponent));
